// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import React from "react";
import { Shield, Home, LogOut, X } from "lucide-react";
import { useKeycloak } from "../../context/KeycloakProvider";

const PermissionPopup = ({ isOpen, onClose, showLogout = true }) => {
  const { logout } = useKeycloak();

  if (!isOpen) return null;

  const handleLogout = () => {
    logout();
    onClose();
  };

  const handleClose = () => {
    onClose();
  };

  const handleContinueBrowsing = () => {
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div className="flex items-center">
            <Shield className="w-8 h-8 text-red-500 mr-3" />
            <h2 className="text-xl font-semibold text-gray-800">
              Access Restricted
            </h2>
          </div>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 transition-colors p-1"
            aria-label="Close popup"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <p className="text-gray-600 mb-6">
            You don&apos;t have sufficient permissions to access admin features.
            Please contact your administrator to request appropriate access.
          </p>

          {/* Actions */}
          <div className="flex flex-col space-y-3">
            {showLogout && (
              <button
                onClick={handleLogout}
                className="inline-flex items-center justify-center px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors w-full"
              >
                <LogOut className="w-4 h-4 mr-2" />
                Logout
              </button>
            )}
            <button
              onClick={handleContinueBrowsing}
              className="inline-flex items-center justify-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors w-full"
            >
              <Home className="w-4 h-4 mr-2" />
              Continue Browsing
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PermissionPopup;
